import { ts_hocsinh_lichsu_yte_chuyenkhoa } from '../models/response/category/ts_hocsinh_lichsu_yte_chuyenkhoa';
import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';

export const CHUYEN_KHOA_API_END_POINT = "chuyen-khoa";

export const chuyenKhoaApi = {
    // Lấy tất cả chuyên khoa
    selectAll: () => apiGuestClient.get(`${CHUYEN_KHOA_API_END_POINT}`),

    // Lấy chi tiết chuyên khoa theo ID
    detail: (id: number) => apiClient.get(`${CHUYEN_KHOA_API_END_POINT}/${id}`),

    // Thêm mới chuyên khoa
    insert: (data: ts_hocsinh_lichsu_yte_chuyenkhoa) => apiClient.post(`${CHUYEN_KHOA_API_END_POINT}`, data),

    // Cập nhật chuyên khoa
    update: (data: ts_hocsinh_lichsu_yte_chuyenkhoa) => apiClient.put(`${CHUYEN_KHOA_API_END_POINT}`, data),

    // Xóa chuyên khoa
    delete: (id: number) => apiClient.delete(`${CHUYEN_KHOA_API_END_POINT}/${id}`),
};
